import { render, staticRenderFns } from "./CustomerTransactions.vue?vue&type=template&id=4e895fc6&scoped=true&"
import script from "./CustomerTransactions.vue?vue&type=script&lang=js&"
export * from "./CustomerTransactions.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransactions.vue?vue&type=style&index=0&id=4e895fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e895fc6",
  null
  
)

export default component.exports